(function ($) {
  $(window).on(' load scroll resize ', function () {
    var $stickyNav = $('.sticky-nav');
    if ($stickyNav.length === 1) {
      $stickyNav.subMenu({
        hideAfter: 767,
        animateTime: 800,
      });
    }
  });
})(jQuery);